import { render, staticRenderFns } from "./AppHistoryDataTable.vue?vue&type=template&id=66e771e8&scoped=true"
import script from "./AppHistoryDataTable.vue?vue&type=script&lang=js"
export * from "./AppHistoryDataTable.vue?vue&type=script&lang=js"
import style0 from "./AppHistoryDataTable.vue?vue&type=style&index=0&id=66e771e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e771e8",
  null
  
)

export default component.exports